import { type HTMLAttributes } from 'react';

import { cn } from '../lib/cn.js';

/** Loading-state placeholder. Always shape-matched to the eventual content. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse-dot rounded bg-surface-muted', className)}
      {...props}
    />
  );
}
